














import { Vue, Component, Prop } from 'vue-property-decorator';
import BusinessLaunchWeApp from '@/components/BusinessLaunchWeApp.vue';

@Component({
  components: {
    BusinessLaunchWeApp,
  },
})
export default class H52WeApp extends Vue {
  /**
   * h5拉起小程序配置
   */
  @Prop()miniappConfig;
}
